import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {share} from 'rxjs/operators';
import {
  OrganizationInformationRestService
} from '../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';
import {GsatData} from '../../../shared/types/nso-data-portal/dashboard-data';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {SearchEntityLevels} from '../../../shared/types/nso-data-portal/search-entity-levels';
import {EntityInformationRestService} from '../../../shared/services/nso-data-portal/rest-services/entity-information-rest.service';

@Component({
  selector: 'wsd-global-support',
  templateUrl: './global-support.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./global-support.component.css']
})
export class GlobalSupportComponent implements OnChanges {

  @Input()
  entityId: number;

  @Input()
  entityLevel: SearchEntityLevels;

  gsat$: Observable<GsatData>;

  assessmentResults: string = '';

  constructor(private organizationService: OrganizationInformationRestService,
              private entityService: EntityInformationRestService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.gsat$ = this.entityService.getGsat({
      entityId: this.entityId,
      level: this.entityLevel
    }).pipe(share());

    if (localStorage.getItem('portal_orgId')) {
      const localStorageEntityData = JSON.parse(localStorage.getItem('portal_orgId'));
      this.assessmentResults = environment.gsWebUrl.concat('/assessment/results?orgId=')
        .concat(localStorageEntityData.entity);
    }
  }

}
